import { toast as RtToast } from 'react-toastify'

/**
 * Wrapper component to make it easier to standardize toasts and migrate libraries if needed
 * @param { ReactComponent | string | number } content what to display on the toast
 * @param { object } options configuration passed to the underlying toast library
 */
function toast(content, options) {
  return RtToast(content, options)
}

toast.info = (content, options) => RtToast.info(content, options)
toast.success = (content, options) => RtToast.success(content, options)
toast.warn = (content, options) => RtToast.warn(content, options)
toast.error = (content, options) => RtToast.error(content, options)
toast.dismiss = (id) => RtToast.dismiss(id)

export { toast }
